import React from 'react';

const Contact = () => {
  return (
    <div className="page contact-page">
      <div className="hero-section">
        <h1>Contact Us</h1>
        <p className="hero-subtitle">
          Have questions or feedback? We'd love to hear from you.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mt-6">
        {/* <div className="card">
          <h2 className="card-title">Get in Touch</h2>
          <form className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2" htmlFor="name">
                Name
              </label>
              <input
                type="text"
                id="name"
                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="Your name"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-2" htmlFor="email">
                Email
              </label>
              <input
                type="email"
                id="email"
                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="your@email.com"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium mb-2" htmlFor="message">
                Message
              </label>
              <textarea
                id="message"
                rows="4"
                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
                placeholder="Your message here..."
              />
            </div>
            
            <button type="submit" className="btn btn-primary w-full">
              Send Message
            </button>
          </form>
        </div> */}

        <div className="space-y-6">
          <div className="card">
            <h3 className="text-xl font-semibold mb-4">Contact Information</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <span className="text-primary text-xl">📧</span>
                <div>
                  <p className="font-medium">Email</p>
                  <p className="text-gray-600">analyticbyte@gmail.com</p>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <span className="text-primary text-xl">📍</span>
                <div>
                  <p className="font-medium">Location</p>
                  <p className="text-gray-600">Analytic Byte, Ghaziabad, Uttar Pradesh 201009</p>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <span className="text-primary text-xl">⏰</span>
                <div>
                  <p className="font-medium">Response Time</p>
                  <p className="text-gray-600">Within 24 hours</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Contact;